import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {ShippingClientListItemDto} from "../../api/fms";

const systemApi = api.fms.api

interface OptionType { label: string, value: string }

class FmsShippingClientOptionsStore {
    get items(): ShippingClientListItemDto[] {
        return this._items;
    }

    set items(value: ShippingClientListItemDto[]) {
        this._items = value;
    }

    get selectOptions(): OptionType [] {
        const result: OptionType[] = []
        result.push(...this.items.map(e => ({
            value: e.id,
            label: e.label
        })))

        return result
    }
    private _items: ShippingClientListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const result = await catchApi(async () => await systemApi.listShippingClients({
            page: 0,
            size: 200
        }))

        const data = result?.data
        if (data?.items) {
            this.items = data.items
        } else {
            this.items = []
        }
    }

}



const fmsShippingClientOptionsStore = new FmsShippingClientOptionsStore()

export {
    fmsShippingClientOptionsStore
}
